export enum AnimalSymbol{
  bird = 102,
  cat = 65,
  cow = 97,
  dog = 66,
  goat = 101,
  hamster = 68,
  horse = 98,
  mouse = 67,
  pig = 99,
  rabbit = 69,
  sheep = 100
}
